import { render, staticRenderFns } from "./IconSearch.vue?vue&type=template&id=a65848e4&"
import script from "./IconSearch.vue?vue&type=script&lang=ts&"
export * from "./IconSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports